import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { isCompositeMonorailEvent } from '../events/events.mjs';

class ConsentTrackingProvider {
  constructor(config) {
    this.version = config.version;
  }
}
class ConsentTrackingMiddleware {
  constructor(config) {
    if ((config === null || config === undefined ? undefined : config.provider) instanceof ConsentTrackingProvider === false) {
      throw new MonorailUnableToInstantiateMiddlewareError('ConsentTrackingMiddleware requires an instance of ConsentTrackingProvider');
    }
    this.provider = config.provider;
  }
  async do(event, proceed) {
    if (isCompositeMonorailEvent(event)) {
      return proceed(await this.provider.annotateEvent(event));
    }
    const annotatedEvent = await Promise.all(event.events.map(event => this.provider.annotateEvent(event)));
    const annotatedBatchedEvent = _objectSpread2(_objectSpread2({}, event), {}, {
      events: annotatedEvent
    });
    return proceed(annotatedBatchedEvent);
  }
}
class MonorailUnableToInstantiateMiddlewareError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, MonorailUnableToInstantiateMiddlewareError.prototype);
  }
}

export { ConsentTrackingMiddleware, ConsentTrackingProvider, MonorailUnableToInstantiateMiddlewareError };
